import { render, staticRenderFns } from "./ApplyingRecord.vue?vue&type=template&id=be0303da&scoped=true&"
import script from "./ApplyingRecord.vue?vue&type=script&lang=js&"
export * from "./ApplyingRecord.vue?vue&type=script&lang=js&"
import style0 from "./ApplyingRecord.vue?vue&type=style&index=0&id=be0303da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0303da",
  null
  
)

export default component.exports